import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {Badge, Button, Form, Layout, message, Modal, Pagination, Space, Table, Tabs} from "antd";
import {Content, Header} from "antd/es/layout/layout";
import styled from "styled-components";
import Input from "antd/es/input/Input";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import {changeUserStatusApi, deleteUserApi, getUserInfoList, resetUsePasswordApi} from "../../http/manager";
import {LoginInfoEntity} from "../../entity/login-info-entity";
import {transaction} from "mobx";
import {useStore} from "../../store";
import {ColumnsType} from "antd/lib/table";
import {UserOperationType} from "../../entity/enum/manager";
import UserModal from "./user-modal";
import ChangePassword from "./editPwd";

const UserManager: React.FC = () => {
    const [form] = Form.useForm()
    const {userInfoStore} = useStore();

    useEffect(() => {
        getUserList({})
        getMenuList()
        return userInfoStore.clear;
    }, []);

    const getMenuList = () => {
        userInfoStore.queryMenuList()
    }

    const getUserList = (params: any) => {
        showFullScreenLoading();
        getUserInfoList(params)
            .then((res) => {
                tryHideFullScreenLoading()
                userInfoStore.pagination.total = res.data ? res.data.total : 0;
                if (res && res.data && res.data.list && res.data.list.length > 0) {
                    refreshTableData(res.data.list)
                } else {
                    refreshTableData([]);
                }
            }).catch((e) => {
            tryHideFullScreenLoading()
            refreshTableData([]);
        });
    }

    const tabChange = (key: string) => {
        if (key === "all") {
            userInfoStore.condition.state = "";
        } else if (key === "online") {
            userInfoStore.condition.state = "1";
        } else if (key === "offline") {
            userInfoStore.condition.state = "0";
        }
        onQuery()
    }

    const changeUserStatus = (record: LoginInfoEntity) => {
        const params = {
            id: record.id,
            state: record.state === 1 ? 0 : 1,
        }
        changeUserStatusApi(params)
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success("更改用户状态成功")
                    onQuery(false)
                } else {
                    message.error("更改用户状态失败")
                }
            }).catch((e) => {
            message.error("更改用户状态失败")
        })
    }

    const deleteUser = (record: LoginInfoEntity) => {
        transaction(() => {
            userInfoStore.isShowDeleteConfirm = true
            userInfoStore.userRecord = record
            userInfoStore.deleteType = 1
        })
    }

    const refreshTableData = (data: LoginInfoEntity[]) => {
        const list: LoginInfoEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        // for (let i=1; i<= 10; i++) {
        //     const item = data[0];
        //     const newItem = new LoginInfoEntity();
        //     newItem.id = (item.id ? item.id : 0) + i;
        //     newItem.key = String(newItem.id);
        //     newItem.state = item.state;
        //     newItem.useraccount = item.useraccount;
        //     newItem.username = item.username;
        //     newItem.department = item.department;
        //     newItem.telephone = item.telephone;
        //
        //     list.push(newItem);
        // }
        transaction(() => {
            userInfoStore.setUserList(list);
            userInfoStore.setColumns(convertColumns());
        })
    }

    const deleteSingleUeser = () => {
        const param = {
            id: userInfoStore.userRecord.id,
        };
        deleteUserApi(param)
            .then((res) => {
                if (Number(res.code) === 200) {
                    transaction(() => {
                        message.success("删除成功");
                        userInfoStore.isShowDeleteConfirm = false
                        userInfoStore.deleteType = 1
                        onQuery()
                    })
                } else {
                    message.error("删除失败");
                }
            }).catch((e) => {
            message.error("删除失败");
        })
    }

    const resetUsePassword = (record: LoginInfoEntity) => {
        const params = {
            id: record.id,
            password: "123456",
        }
        resetUsePasswordApi(params)
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success("重置密码成功");
                } else {
                    message.error("重置密码失败");
                }
            }).catch(() => {
            message.error("重置密码失败");
        })
    }

    const editUsePassword = (record: LoginInfoEntity)=> {
        userInfoStore.setEditModalShow(true);
        userInfoStore.setChangeInfo(record);
    }

    const convertColumns = () => {
        const columns: ColumnsType<LoginInfoEntity> = [
            {
                title: '人员姓名',
                width: 100,
                dataIndex: 'username',
                key: 'username',
                align: "center"
            },
            {
                title: '登录账户',
                width: 100,
                dataIndex: 'useraccount',
                key: 'useraccount',
                align: "center"
            },
            {
                title: '联系方式',
                width: 100,
                dataIndex: 'telephone',
                key: 'telephone',
                align: "center"
            },
            {
                title: '部门名称',
                width: 100,
                dataIndex: 'department',
                key: 'department',
                align: "center"
            },
            {
                title: '状态',
                width: 100,
                dataIndex: 'state',
                key: 'state',
                align: "center",
                render: (vale, record) => {
                    return <Badge status={record.state === 1 ? "success" : "default"}
                                  text={record.state === 1 ? "已启用" : "停用"}/>
                }
            },
            {
                title: '创建时间',
                width: 200,
                dataIndex: 'createtime',
                key: 'createtime',
                sorter: false,
                align: "center"
            },
            {
                title: '操作',
                width: 300,
                dataIndex: 'collectionDate',
                key: 'collectionDate',
                align: "center",
                render: (value, record) => {
                    return <Space size="middle">
                        <a onClick={() => editUserModal(record)}>编辑</a>
                        <a style={{color: "#ff0000"}} onClick={() => deleteUser(record)}>删除</a>
                        { record.state === 1 ? <a style={{color: "#d3d3d3"}} onClick={() => changeUserStatus(record)}>停用</a> : <a onClick={() => changeUserStatus(record)}>启用</a>}
                        {/* {record.state === 1 ? <span style={{color: "#d3d3d3"}}>启用</span> :
                            <a onClick={() => changeUserStatus(record)}>启用</a>}
                        {record.state === 0 ? <span style={{color: "#d3d3d3"}}>停用</span> :
                            <a onClick={() => changeUserStatus(record)}>停用</a>} */}
                        <a onClick={(() => resetUsePassword(record))}>密码重置</a>
                        <a onClick={(() => editUsePassword(record))}>密码修改</a>
                    </Space>
                }
            }
        ];
        return columns;
    }

    const onNameChange = (e: any) => {
        userInfoStore.condition.username = e.target.value;
    }

    const onAccountChange = (e: any) => {
        userInfoStore.condition.useraccount = e.target.value;
    }

    const onDepartmentChange = (e: any) => {
        userInfoStore.condition.department = e.target.value;
    }

    const onQueryReset = () => {
        userInfoStore.resetQuery()
        onQuery()
    }

    const onQuery = (isClear = true) => {
        if (isClear) {
            userInfoStore.selectRows = [];
        }
        userInfoStore.queryUserInfo(true)
            .then((res) => {
                userInfoStore.pagination.total = res.data ? res.data.total : 0;
                if (res && res.data && res.data.list.length > 0) {
                    refreshTableData(res.data.list)
                } else {
                    refreshTableData([]);
                }
            }).catch(() => {
            refreshTableData([]);
        });
    }

    const deleteUserByBatch = () => {
        if (userInfoStore.selectRows && userInfoStore.selectRows.length > 0) {
            transaction(() => {
                userInfoStore.deleteType = 2
                userInfoStore.isShowDeleteConfirm = true
            })
        } else {
            message.error("请先选择用户！");
        }
    }

    const deleteBatchUser = () => {
        const rowId = userInfoStore.selectRows.map((item) => item.id);
        const selectIds = rowId.join(",");
        const param = {
            id: selectIds,
        }
        deleteUserApi(param)
            .then((res) => {
                if (Number(res.code) === 200) {
                    transaction(() => {
                        message.success("删除成功");
                        userInfoStore.deleteType = 1
                        userInfoStore.isShowDeleteConfirm = false
                        onQuery()
                    })
                } else {
                    message.error("删除失败");
                }
            }).catch((e) => {
            message.error("删除失败");
        })
    }

    const onUserModalClose = () => {
        userInfoStore.modalClear()
        userInfoStore.setUseOperationModal(false)
    }

    const addUserModal = () => {
        transaction(() => {
            userInfoStore.userType = UserOperationType.ADD;
            userInfoStore.setUseEditInfo(new LoginInfoEntity());
            userInfoStore.menuKey = []
            form.setFieldsValue(userInfoStore.useEditInfo)
            userInfoStore.setUseOperationModal(true);
        })
    }

    const editUserModal = (record: LoginInfoEntity) => {
        transaction(() => {
            userInfoStore.userType = UserOperationType.EDIT;
            userInfoStore.setUseEditInfo(record);
            userInfoStore.menuKey = record.selectMenuKey ? record.selectMenuKey.split(",") : []
            form.setFieldsValue(userInfoStore.useEditInfo)
            userInfoStore.setUseOperationModal(true);
        })
    }

    const onOperationSuccess = () => {
        userInfoStore.setUseOperationModal(false);
        onQuery(false)
    }

    const onSizeChange = (page: any, pageSize: any) => {
        userInfoStore.pagination.pageSize = pageSize;
        userInfoStore.pagination.pageNum = page;
        onQuery();
    }

    const deleteButton = () => {
        if (userInfoStore.deleteType === 1) {
            deleteSingleUeser()
        } else {
            deleteBatchUser()
        }
    }

    const onDeleteConfirmClose = () => {
        transaction(() => {
            userInfoStore.isShowDeleteConfirm = false
            userInfoStore.userRecord = new LoginInfoEntity()
        })
    }
    const onEditClose = () => {
        userInfoStore.setEditModalShow(false);
    }
    const onEditSuccess = () => {
        userInfoStore.setEditModalShow(false);
        onQuery();
    }
    return (
        <Layout style={{height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding: "0 0 0 0"}}>
                <TitleSpan>用户管理</TitleSpan>
            </Header>
            <Content style={{flex: 1, overflow: 'hidden'}}>
                <Wrapper>
                    <SearchWrapper>
                        <Space>
                            <Button onClick={addUserModal} type={"primary"}
                                    style={{width: "100px", margin: "15px 0 15px 15px"}} size={"large"}>新建</Button>
                        </Space>
                        <Space size={"small"} style={{padding: "0px 15px 0 15px"}} align={"start"}
                               direction={"horizontal"} wrap={true}>
                            <Form.Item label={"人员姓名"}><Input onChange={onNameChange}
                                                                 value={userInfoStore.condition.username}
                                                                 placeholder={"请输入"}/></Form.Item>
                            <Form.Item label={"登录账户"}><Input onChange={onAccountChange}
                                                                 value={userInfoStore.condition.useraccount}
                                                                 placeholder={"请输入"}/></Form.Item>
                            <Form.Item label={"部门"}><Input onChange={onDepartmentChange}
                                                             value={userInfoStore.condition.department}
                                                             placeholder={"请输入"}/></Form.Item>
                            <Button style={{marginLeft: "20px"}} type={"primary"}
                                    onClick={() => onQuery()}>查询</Button>
                            <Button type={"default"} onClick={onQueryReset}>重置</Button>
                        </Space>
                    </SearchWrapper>
                    <ContentWrapper>
                        <Tabs
                            type={"card"} size={"small"}
                            style={{padding: "20px 0 10px 15px"}}
                            items={userInfoStore.tabItems}
                            defaultActiveKey={"all"}
                            onChange={tabChange}
                        />
                        <Table
                            rowClassName={(type, index, intent) => {
                                return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            style={{margin: "0 20px 0 20px"}}
                            size={"middle"}
                            bordered={true}
                            columns={userInfoStore.columns}
                            dataSource={userInfoStore.userList}
                            pagination={{position: [], pageSize: userInfoStore.pagination.pageSize}}
                        />
                        <Pagination
                            size={"small"}
                            style={{margin: "20px 20px 20px 0", alignSelf: "end"}}
                            total={userInfoStore.pagination.total}
                            showQuickJumper={true}
                            showSizeChanger={true}
                            defaultPageSize={10}
                            hideOnSinglePage={false}
                            onChange={onSizeChange}
                            current={userInfoStore.pagination.pageNum}
                        />
                    </ContentWrapper>
                </Wrapper>
                <Modal
                    open={userInfoStore.isUserOperationModal}
                    onCancel={onUserModalClose}
                    closable={true}
                    centered={true}
                    title={userInfoStore.userType === UserOperationType.ADD ? "用户新增" : "用户编辑"}
                    footer={null}
                    mask={true}
                    maskClosable={true}
                    width={"500px"}>
                    <UserModal onSuccess={onOperationSuccess} form={form}/>
                </Modal>
                <Modal onCancel={onDeleteConfirmClose}
                       onOk={deleteButton}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={userInfoStore.isShowDeleteConfirm}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认删除该数据</div>
                </Modal>
                <Modal
                    open={userInfoStore.editModalShow}
                    onCancel={onEditClose}
                    closable={true}
                    centered={true}
                    title={"修改密码"}
                    footer={null}
                    mask={true}
                    maskClosable={true}
                    width={"500px"}>
                    <ChangePassword onSuccess={onEditSuccess}/>
                </Modal>
            </Content>
        </Layout>
    );
}

export default observer(UserManager);

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-table-body {
      overflow-x: scroll !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;